const NOTICE_KEY = "icecys.permissionNotice";
const SESSION_KEY = "icecys.permissionSession";

const permissionFrom = (response, text) => {
    const header = response.headers.get("X-Required-Permission") || response.headers.get("X-Permission");
    if (header) return header;

    const match = String(text || "").match(/(?:required\s+)?permission[^a-z0-9:_*]+([a-z][a-z0-9_-]*:[a-z0-9_*-]+)/i);
    return match?.[1] || null;
};

export const getPermissionNotice = () => {
    try {
        const raw = sessionStorage.getItem(NOTICE_KEY);
        return raw ? JSON.parse(raw) : null;
    } catch {
        return null;
    }
};

export const clearPermissionNotice = () => sessionStorage.removeItem(NOTICE_KEY);

// Clears the whole recovery pair (notice + stashed session), not just the
// banner. Must run on an explicit logout and on a fresh successful login —
// otherwise a stale dead-token backup from an earlier 403 can resurrect
// itself via restorePermissionSession() and silently undo either one.
export const clearPermissionRecovery = () => {
    sessionStorage.removeItem(NOTICE_KEY);
    sessionStorage.removeItem(SESSION_KEY);
};

export const hasPermissionRecovery = () => Boolean(
    sessionStorage.getItem(NOTICE_KEY) && sessionStorage.getItem(SESSION_KEY)
);

export const restorePermissionSession = () => {
    if (!hasPermissionRecovery() || localStorage.getItem("user")) return null;
    const saved = sessionStorage.getItem(SESSION_KEY);
    if (saved) localStorage.setItem("user", saved);
    return saved;
};

export const reportPermissionDenied = async (response, request) => {
    const user = localStorage.getItem("user");
    if (user) sessionStorage.setItem(SESSION_KEY, user);

    const url = typeof request === "string" ? request : request?.url || "";
    const initialNotice = { permission: null, url, status: 403 };
    sessionStorage.setItem(NOTICE_KEY, JSON.stringify(initialNotice));
    window.dispatchEvent(new CustomEvent("icecys-permission-denied", { detail: initialNotice }));

    try {
        const text = await response.clone().text();
        const notice = { ...initialNotice, permission: permissionFrom(response, text) };
        sessionStorage.setItem(NOTICE_KEY, JSON.stringify(notice));
        window.dispatchEvent(new CustomEvent("icecys-permission-denied", { detail: notice }));
    } catch {
        // The generic 403 notice above is still useful when a proxy returns no body.
    }
};
